var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { legacy } from "./legacy";
import { data } from "./data";
import { foundation } from "./foundation";
// legacy exports for backwards compatibility
export var yulifePink = legacy.yulifePink;
export var uncommonGreen = legacy.uncommonGreen;
export var rareBlue = legacy.rareBlue;
export var epicPurple = legacy.epicPurple;
export var legendaryYellow = legacy.legendaryYellow;
var colours = __assign(__assign(__assign(__assign({ white: "#FFFFFF", black: "#000000" }, legacy), data), foundation), { status: __assign(__assign({}, legacy.status), foundation.status) });
export default colours;
